import React from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import ButtonLoader from "../ButtonLoader";

const ReopenVqqConfirmModal = ({
  open,
  onClose,
  onConfirm,
  loading = false,
  vendorName,
}) => {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 backdrop-blur-sm bg-transparent transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl ring-1 ring-gray-200 transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-indigo-100">
              <ArrowPathIcon
                className="size-6 text-indigo-600"
                aria-hidden="true"
              />
            </div>

            <div className="mt-3 text-center sm:mt-5">
              <DialogTitle
                as="h3"
                className="text-base font-semibold text-gray-900"
              >
                Reopen VQQ
              </DialogTitle>
              <div className="mt-3">
                <p className="text-sm text-gray-700 leading-relaxed">
                  Are you sure you want to reopen the{" "}
                  <span className="font-semibold">
                    {vendorName || "this"}
                  </span>{" "}
                  VQQ? It will move out of Complete and resume as an active
                  questionnaire.
                </p>
              </div>
            </div>

            <div className="mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
              <button
                type="button"
                onClick={onConfirm}
                disabled={loading}
                className={`inline-flex w-full justify-center items-center gap-2 rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm sm:col-start-2 transition ${
                  loading
                    ? "bg-custom-link-bg-color/70 cursor-not-allowed"
                    : "bg-custom-link-bg-color hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                }`}
              >
                {loading ? (
                  <>
                    <ButtonLoader />
                    <span>Reopening…</span>
                  </>
                ) : (
                  "Reopen VQQ"
                )}
              </button>
              <button
                type="button"
                onClick={onClose}
                disabled={loading}
                data-autofocus
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
              >
                Cancel
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default ReopenVqqConfirmModal;
